module.exports = __webpack_public_path__ + "img/kankou_3.ca1191b6.jpg";